import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="content has-text-centered">
          <div className="footer-links">
            <a className="icon-link" href="#">
              <i className="fas fa-file-pdf"></i>
            </a>
            <a className="icon-link" href="https://github.com/siddhxrth/IPO-Mine">
              <i className="fab fa-github"></i>
            </a>
          </div>
          <div className="columns is-centered">
            <div className="column is-8">
              <p>
                <strong>IPOMine</strong> is an open-source research project. 
                Code and data are available under the <strong>CC BY 4.0</strong> license.
              </p>
              <p className="footer-copyright">
                © {new Date().getFullYear()} IPO-Mine Research Team
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
